module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Regular-1b23ca7665a10d5a0e20ba931523745b.woff2";